import { useState } from "react";
import BusinessSidebar, { type BusinessSection } from "./components/BusinessSidebar";
import BusinessTopBar from "./components/BusinessTopBar";
import ProfileSection from "./sections/ProfileSection";
import GallerySection from "./sections/GallerySection";
import BusinessCampaignsSection from "./sections/BusinessCampaignsSection";
import BusinessSupportSection from "./sections/BusinessSupportSection";
import { BrochureSection, AdvertiseSection, ContactSection } from "./sections/BusinessExtrasSections";
import { businessTickets } from "../../mocks/businessData";

export default function BusinessPage() {
  const [section, setSection] = useState<BusinessSection>("profile");
  const [collapsed, setCollapsed] = useState(false);

  const openTickets = businessTickets.filter((t) => t.status === "open").length;

  const renderSection = () => {
    switch (section) {
      case "profile":   return <ProfileSection />;
      case "gallery":   return <GallerySection />;
      case "campaigns": return <BusinessCampaignsSection />;
      case "support":   return <BusinessSupportSection />;
      case "brochure":  return <BrochureSection />;
      case "advertise": return <AdvertiseSection />;
      case "contact":   return <ContactSection />;
      default:          return <ProfileSection />;
    }
  };

  return (
    <div className="flex min-h-screen bg-stone-50">
      <BusinessSidebar
        active={section}
        onNavigate={setSection}
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        openTickets={openTickets}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <BusinessTopBar section={section} />
        <main className="flex-1 p-6 overflow-y-auto">
          <div className="max-w-5xl mx-auto">
            {renderSection()}
          </div>
        </main>

        {/* Footer */}
        <div className="px-6 py-3 border-t border-stone-100 bg-white flex items-center justify-between text-xs text-stone-400">
          <span>BursaGuide360 İşletme Paneli</span>
          <a href="mailto:destek@bursaguide360.com" className="hover:text-stone-600 transition-colors cursor-pointer">
            destek@bursaguide360.com
          </a>
        </div>
      </div>
    </div>
  );
}
